export type QuestionData = {
    question: string;
    answer: number;
    feedback: string;
    takeCardNumber: number;
};

export const questionData: { [key: number]: QuestionData } = {
    0: {
        question: 'Quel âge va avoir Harvey Yeuse la semaine prochaine ?',
        answer: 2,
        feedback:
            'Bonne réponse ! Harvey Yeuse va bientôt avoir 2 mois.',
        takeCardNumber: 0,
    },
    1: {
        question: 'À partir de quel âge\nconstate-t-on\u00A0une hausse des cas de méningite ?',
        answer: 4,
        feedback:
            'Effectivement, on constate une forte hausse des méningites à partir du 4e mois.',
        takeCardNumber: 0,
    },
    2: {
        question: 'Quel âge aura Harvey Yeuse lors de son concert ?',
        answer: 5,
        feedback:
            'Harvey Yeuse aura <span class="bold">5 mois</span> au moment du concert, en plein dans <span class="bold">la fenêtre de vulnérabilité de 4 à 11 mois</span>. Il a <span class="bold">bientôt 2 mois</span>, il doit donc recevoir sa première dose de vaccin prochainement.',
        takeCardNumber: 93,
    },
};
